import { DetailView } from '@components/enitity'
import { Loader } from '@components/loader/Loader'
import { useSettlementDetail } from '@services/settlements/queries/useSettlementDetail'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { SettlementStatusBar } from '../../components/SettlementStatusBar'
import { SettlementWizard } from '../../components/wizard/SettlementWizard'

export function SettlementDetail() {
  const { id } = useParams()
  const { t } = useTranslation('settlement')
  const { data, isLoading } = useSettlementDetail({ id })

  if (isLoading) return <Loader />
  if (!data) return <div>{t('empty.title')}</div>

  return (
    <div className="space-y-6">
      <DetailView.Breadcrumb
        parentLabel={data.flat.title}
        parentTo={`/admin/flats/${data.flat.id}?tab=settlements`}
        current={data.title}
      />

      <SettlementStatusBar settlement={data} />

      {data.status === 'PUBLISHED' && (
        <p className="m-0 rounded-xl bg-ink/[0.04] px-4 py-3 text-sm text-muted-foreground">
          {t('readonly')}
        </p>
      )}

      <SettlementWizard settlement={data} />
    </div>
  )
}
